import React from 'react';
import PropTypes from 'prop-types';
import { withHandlers } from 'recompose';
import { compose } from 'ramda';

import LocalizedLink from 'app/features/localization/components/LocalizedLink/LocalizedLink';
import { homeSelected } from 'app/features/header/actions';
import { HOME_URL } from 'app/router/constants/externalUrls';
import S from 'app/features/header/components/buttons/LogoButton.styled';
import { HEADER_LEFT } from 'app/analytics/constants/positions';
import connect from 'app/libs/connect';
import { CRUNCHYROLL } from 'app/constants/constants';

const UI = ({ onClick }) => (
  <S.LogoButton as={LocalizedLink} to={HOME_URL} onClick={onClick}>
    <S.Logo
      src={`${window.etp.config.assetsUrl}img/logo/cr_logo.png`}
      srcSet={`${window.etp.config.assetsUrl}img/logo/cr_logo@2x.png 2x`}
      alt="Crunchyroll Logo"
      data-t="header-logo"
    />
  </S.LogoButton>
);

UI.propTypes = { onClick: PropTypes.func.isRequired };

UI.displayName = 'LogoButton';

const onClick =
  ({ homeSelected }) =>
  () => {
    homeSelected({ position: HEADER_LEFT, textOfButtonOrLink: CRUNCHYROLL });
  };

const LogoButton = compose(
  connect(null, { homeSelected }),
  withHandlers({ onClick }),
)(UI);

export { UI, onClick };

export default LogoButton;
